<template>
	<div>
		<loading v-if="isHint"></loading>
		<div v-if="!isHint" fillHeight="lastHeight" scroll>
			<div v-show="isManual" class="w90pct mc mt2x">
				<div class="panel bgPanel mt1x pl2x pt2x pb2x pr2x emptyToken_EE">
					<ul class="fs12x" v-if="basicInfo">
						<li class="dpIB_E w100pct"><span class="w50pct b">{{$t('word1421',['当前设置方式'])}}</span><span class="w50pct b" :title="SettingStrategy(metering.statisticMethodSettingStrategy)">{{SettingStrategy(metering.statisticMethodSettingStrategy)}}</span></li>
					<li class="dpIB_E w100pct mt1x cb clearfix" v-if="this.powerType=='light'">
							<span class="w50pct fL">{{$t('word1479',['辐照'])}}</span>
							<span class="w50pct fL" v-if="metering.statisticMethodSettingStrategy=='STATIC'">{{metering.irradianceMethod?metering.irradianceMethod:getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy=='DYNAMIC'">{{stationInfo&&stationInfo.irradianceStatisticMethod?stationInfo.irradianceStatisticMethod:getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy==null">--</span>
						</li>
						<li class="dpIB_E w100pct mt1x cb clearfix" v-if="stage.loc.customer=='SOLARMAN'&&this.powerType=='light'">
							<span class="w50pct fL">{{$t('plant_detail21',['理论发电'])}}</span>
							<span class="w50pct fL" v-if="metering.statisticMethodSettingStrategy=='STATIC'">{{metering.theoreticalStatisticMethod?metering.theoreticalStatisticMethod:getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy=='DYNAMIC'">{{stationInfo&&stationInfo.theoreticalStatisticMethod?stationInfo.theoreticalStatisticMethod:getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy==null">--</span>
						</li>
						<li class="dpIB_E w100pct mt1x cb clearfix">
							<span class="w50pct fL">{{$t('word559',['发电'])}}</span>
							<span class="w50pct fL" v-if="metering.statisticMethodSettingStrategy=='STATIC'">{{selectZh(metering.generationStatisticMethod)}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy=='DYNAMIC'">{{stationInfo&&stationInfo.generationStatisticMethod?selectZh(stationInfo.generationStatisticMethod):getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy==null">--</span>
						</li>
						<li class="dpIB_E w100pct mt1x cb clearfix" v-if="basicInfo.gridInterconnectionType=='EXCESS'||basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
							<span class="w50pct fL">{{$t('word560',['电网'])}}</span>
							<span class="w50pct fL" v-if="metering.statisticMethodSettingStrategy=='STATIC'">{{selectZh(metering.utilityStatisticMethod)}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy=='DYNAMIC'">{{stationInfo&&stationInfo.gridStatisticMethod?selectZh(stationInfo.gridStatisticMethod):getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy==null">--</span>
						</li>
						<li class="dpIB_E w100pct mt1x cb clearfix" v-if="basicInfo.gridInterconnectionType=='EXCESS'||basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
							<span class="w50pct fL">{{$t('word561',['用电'])}}</span>
							<span class="w50pct fL" v-if="metering.statisticMethodSettingStrategy=='STATIC'">{{selectZh(metering.consumptionStatisticMethod)}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy=='DYNAMIC'">{{stationInfo&&stationInfo.consumptionStatisticMethod?selectZh(stationInfo.consumptionStatisticMethod):getLanguageStr('word116','无')}}</span>
							<span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy==null">--</span>
						</li>
            <li class="dpIB_E w100pct mt1x cb clearfix" v-if="basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
							<span class="w50pct fL">{{$t('word37',['电池'])}}</span>
							<span class="w50pct fL" v-if="metering.statisticMethodSettingStrategy=='STATIC'">{{selectZh(metering.batteryStatisticMethod)}}</span>
              <span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy=='DYNAMIC'">{{stationInfo&&stationInfo.batteryStatisticMethod?selectZh(stationInfo.batteryStatisticMethod):getLanguageStr('word116','无')}}</span>
              <span class="w50pct fL" v-else-if="metering.statisticMethodSettingStrategy==null">--</span>
						</li>
						<li v-if="metering.statisticMethodSettingStrategy=='DYNAMIC'" class="mt2x">
							<div class="pt05x pb05x taC bgLight">{{getLanguageStr('phrase998','系统智能选择结果会在5～10分钟内体现，请耐心等待')}}</div>
						</li>
					</ul>
				</div>
				<div class="taC vaM_E w11x-min_E">
					<button class="functionBtn mt4x mr2x sizeM" type="button" @click="change">{{getLanguageStr('plant_detail120','手动修改')}}</button>
					<button class="functionBtn mt4x sizeM" type="button" @click="saveStatic">{{getLanguageStr('cmd265','设为系统智能选择')}}</button>
				</div>
			</div>
			<div v-show="!isManual">
				<div class="mb2x pl2x pr2x mt2x" v-if="basicInfo.gridInterconnectionType =='DISTRIBUTED_FULLY'" v-html="$t('fill3rd131',['<span class=\'cMain\'>'+getLanguageStr('word741','分布式全额上网')+'</span>','以下为XXX电站系统电流流动模拟图,请设置各数据类型的数据来源'])"></div>
				<div class="mb2x pl2x pr2x mt2x" v-if="basicInfo.gridInterconnectionType=='BATTERY_BACKUP'" v-html="$t('fill3rd131',['<span class=\'cMain\'>'+getLanguageStr('word308','储能储能')+'</span>','以下为XXX电站系统电流流动模拟图,请设置各数据类型的数据来源'])"></div>
				<div class="mb2x pl2x pr2x mt2x" v-if="basicInfo.gridInterconnectionType=='EXCESS'" v-html="$t('fill3rd131',['<span class=\'cMain\'>'+getLanguageStr('word742','分布式自发自用余电上网')+'</span>','以下为XXX电站系统电流流动模拟图,请设置各数据类型的数据来源'])"></div>
	      <div class="mb2x pl2x pr2x mt2x" v-show="this.powerType=='light'" v-if="basicInfo.gridInterconnectionType=='CENTRALIZED_FULLY'" v-html="$t('fill3rd131',['<span class=\'cMain\'>'+getLanguageStr('plant398','集中式全额上网')+'</span>','以下为XXX电站系统电流流动模拟图,请设置各数据类型的数据来源'])"></div>				<!-- <div class="mb2x pl2x pr2x mt2x">以下为<span class="cMain" v-if="basicInfo.gridInterconnectionType !=='EXCESS'">分布式全额上网</span><span class="cMain" v-else>分布式自发自用余量并网</span>电站系统电流流动模拟图,请设置各数据类型的数据来源</div> -->
				<!-- <div class="mb1x w80pct mc" v-show="basicInfo.gridInterconnectionType !=='EXCESS'">
					<div class="img-box posR">
						<div class="w100pct">
							<div class="w8x h10x posR">
								<svg class="w3x h3x dpIB fYellow">
									<use xlink:href="#ico-weather-sunny"></use>
								</svg>
								<div class="h4x"></div>
								<div class="taR vaM_E">
									<span class="lText fs12x">{{getLanguageStr('word559','发电')}}</span>
									<svg class="w3x h3x fSub dpIB">
										<use xlink:href="#ico-getPower"></use>
									</svg>
								</div>
								<DashLine class="LDash transformDashLine" :dashLine="false" :viewWidth="60" :viewHeight="10" ></DashLine>
							</div>
							<div>

							</div>
						</div>
					</div>
				</div> -->
				<div class="mb1x w80pct mc" v-show="basicInfo.gridInterconnectionType =='DISTRIBUTED_FULLY'||basicInfo.gridInterconnectionType =='CENTRALIZED_FULLY'">
					<div class="img-box posR">
						<img src="/static/image/unexcess.png" alt="" class="w100pct" v-if="stage.loc.customer=='SOLARMAN'&&this.powerType=='light'">
						<img src="/static/image/unexcessAts.png" alt="" class="w100pct" v-if="stage.loc.customer!='SOLARMAN'&&this.powerType=='light'">
						<img src="/static/image/unexcessFan.png" alt="" class="w100pct" v-if="this.powerType=='wind'">
						<div class="excessLBText dpN-min fs12x posA" v-if="stage.loc.customer=='SOLARMAN'&&this.powerType=='light'">{{getLanguageStr('plant_detail21','理论发电')}}</div>
						<div class="dpN-min fs12x posA" :class="this.powerType=='light'?'lText':'fanlText'">{{getLanguageStr('word559','发电')}}</div>
						<div class="dpN-min fs12x posA" :class="this.powerType=='light'?'rText':'fanrText'">{{getLanguageStr('word560','电网')}}</div>
					</div>
				</div>
                <div class="mb1x w80pct mc" v-show="basicInfo.gridInterconnectionType =='BATTERY_BACKUP'">
					<div class="img-box posR">
						<img src="/static/image/batteryFlow.png" alt="" class="w100pct" v-if="stage.loc.customer=='SOLARMAN'">
						<img src="/static/image/batteryFlowAts.png" alt="" class="w100pct" v-else>
						<div class="batterylText dpN-min fs12x posA">{{getLanguageStr('word559','发电')}}</div>
						<div class="batteryrText dpN-min fs12x posA">{{getLanguageStr('word560','电网')}}</div> 
						<div class="batteryLBText dpN-min fs12x posA" v-if="stage.loc.customer=='SOLARMAN'">{{getLanguageStr('plant_detail21','理论发电')}}</div>
						<div class="batteryBText dpN-min fs12x posA">{{getLanguageStr('word37','电池')}}</div>
						<div class="batteryBRText dpN-min fs12x posA">{{getLanguageStr('word561','用电')}}</div>
						
					</div>
				</div>
				<div  class="mb1x w80pct mc" v-show="basicInfo.gridInterconnectionType =='EXCESS'">
					<div class="img-box posR">
						<img src="/static/image/excess.png" alt="" class="w100pct" v-if="!isPurchase&&stage.loc.customer=='SOLARMAN'">
						<img src="/static/image/excessP.png" alt="" class="w100pct" v-if="isPurchase&&stage.loc.customer=='SOLARMAN'">
						<img src="/static/image/excessAts.png" alt="" class="w100pct" v-if="!isPurchase&&stage.loc.customer!='SOLARMAN'">
						<img src="/static/image/excessPAts.png" alt="" class="w100pct" v-if="isPurchase&&stage.loc.customer!='SOLARMAN'">
						<div class="excessLText dpN-min fs12x posA">{{getLanguageStr('word559','发电')}}</div>
						<div class="excessFLBText dpN-min fs12x posA" v-if="stage.loc.customer=='SOLARMAN'">{{getLanguageStr('plant_detail21','理论发电')}}</div>
						<div class="excessRText dpN-min fs12x posA" v-if="!isPurchase">{{getLanguageStr('word560','电网')}}</div>
						<div class="excessRText dpN-min fs12x posA" v-else>{{getLanguageStr('word189','购电')}}</div>
						<div class="excessBText dpN-min fs12x posA">{{getLanguageStr('word561','用电')}}</div>
						<div class="cMain switchText fs12x posA curP" @click="isPurchase=!isPurchase">{{getLanguageStr('cmd227','点击切换')}}</div>
					</div>
				</div>
				<div v-if="basicInfo"  class="w80pct mc mt3x pb2x">
					<div class="flexSys mb2x" v-if="this.powerType=='light'">
						<div><div class="round bgMain mr2x">1</div></div>
						<div class="flex1">
							<div class="mb2x fs12x l18x"><span class="cSub mr1x">{{getLanguageStr('word1741','数据类型')}}</span>{{getLanguageStr('phrase854','辐照（包括辐照强度、辐照量）')}}</div>
							<div class="dpIB_E vaM_E">
								<span class="cSub fs12x l18x mr1x">{{$t('word1364',['数据来源'])}}</span>
								<Select :list="weather.data" @Click="activeIrradiance" :bindActive="activeIndex.irradianceAvailable" :keyMap="{text:'textSerialNumber',value:'serialNumber'}" class="w60pct fs12x h2x"></Select>
								
							</div>
						</div>
					</div>
					<div class="flexSys mb2x"  v-if="stage.loc.customer=='SOLARMAN'&&this.powerType=='light'">
						<div><div class="round bgMain mr2x">2</div></div>
						<div class="flex1">
							<div class="mb2x fs12x l18x"><span class="cSub mr1x">{{getLanguageStr('word1741','数据类型')}}</span>{{$t('plant_detail32',['理论发电（包括理论发电量）'])}} </div>
							<div class="dpIB_E vaM_E">
								<span class="cSub fs12x l18x mr1x">{{$t('word1364',['数据来源'])}}</span>
								<Select :list="weatherTheoretical.data" @Click="theoreticalStatisticMethod" :bindActive="activeIndex.theoreticalStatisticMethod" v-model="activeIndex.theoreticalStatisticMethod" :keyMap="{text:'textSerialNumber',value:'serialNumber'}" class="w60pct fs12x h2x"></Select>
							</div>
						</div>
					</div>
					<div class="flexSys mb2x">
						<div><div class="round bgMain mr2x"><span v-if="this.powerType=='light'">3</span><span v-else>1</span></div></div>
						<div class="flex1">
							<div class="mb2x fs12x l18x"><span class="cSub mr1x">{{getLanguageStr('word1741','数据类型')}}</span>{{$t('word1964',['发电（包括发电功率、发电量）'])}}</div>
							<div class="dpIB_E vaM_E">
								<span class="cSub fs12x l18x mr1x">{{$t('word1364',['数据来源'])}}</span>
								<Select :list="selectHint.generationAvailable" @Click="activeGeneration" v-model="activeIndex.generationAvailable" :bindActive="activeIndex.generationAvailable" :keyMap="{text:'name',value:'value'}" class="w60pct fs12x h2x"></Select>
							</div>
						</div>
					</div>
					<div class="flexSys mb2x" v-show="basicInfo.gridInterconnectionType=='EXCESS'||basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
						<div><div class="round bgMain mr2x">4</div></div>
						<div class="flex1">
							<div class="mb2x fs12x l18x"><span class="cSub mr1x">{{getLanguageStr('word1741','数据类型')}}</span>{{$t('word1967',['电网（包括电网功率、电网状态、并网量、购电量）'])}}</div>
							<div class="dpIB_E vaM_E">
								<span class="cSub fs12x l18x mr1x">{{$t('word1364',['数据来源'])}}</span>
								<Select :list="selectHint.gridAvailable" @Click="activeUtility" v-model="activeIndex.gridAvailable" :bindActive="activeIndex.gridAvailable" :keyMap="{text:'name',value:'value'}" class="w60pct fs12x h2x" ></Select>
							</div>
						</div>
					</div>
					 	<div class="flexSys mb2x" v-show="basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
									<div><div class="round bgMain mr2x">5</div></div>
									<div class="flex1">
										<div class="mb2x fs12x l18x"><span class="cSub mr1x">{{getLanguageStr('word1741','数据类型')}}</span>{{$t('word2007',['电池（包括电池功率、电池状态、充电量、放电量、电池剩余容量）'])}} </div>
										<div class="dpIB_E vaM_E">
											<span class="cSub fs12x l18x mr1x">{{$t('word1364',['数据来源'])}}</span>
											<Select :list="selectHint.batteryStatisticMethod" :bindActive="activeIndex.batteryStatisticMethod" v-model="activeIndex.batteryStatisticMethod" @Click="batteryStatisticMethodClick" :keyMap="{text:'name',value:'value'}" class="w60pct fs12x h2x"></Select>
										</div>
									</div>
								</div>
					<div class="flexSys " v-show="basicInfo.gridInterconnectionType=='EXCESS'||basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
						<div><div class="round bgMain mr2x"><span  v-if="basicInfo.gridInterconnectionType=='EXCESS'">5</span><span v-else>6</span></div></div>
						<div class="flex1">
							<div class="mb2x fs12x l18x"><span class="cSub mr1x">{{getLanguageStr('word1741','数据类型')}}</span>{{$t('word561',['用电'])}}({{getLanguageStr('plant311','包括用电功率、用电量')}}) </div>
							<div class="dpIB_E vaM_E">
								<span class="cSub fs12x l18x mr1x">{{$t('word1364',['数据来源'])}}</span>
								<Select :list="selectHint.consumptionAvailable" :bindActive="activeIndex.consumptionAvailable" v-model="activeIndex.consumptionAvailable" @Click="activeConsumption" :keyMap="{text:'name',value:'value'}" class="w60pct fs12x h2x"></Select>
							</div>
						</div>
					</div>
			         
					<div class="taC">
						<button class="sizeM bdSub boxR hover-bg-highLight w9x mt3x mr2x" type="button" @click="cancel">{{$t('cmd85',['取消'])}}</button>
						<button class="functionBtn w9x mt3x sizeM" type="button" @click="saveSetting">{{$t('cmd84',['保存'])}}</button>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/common/ui/Loading'
import * as lib from '@/util/lib'
import * as configApi from '@/api/maintain/config'
import * as equipmentApi from '@/api/maintain/plant/list'
import {StationMeteringSetting, StationMeteringStrategy, StationInfo, StationBasicInfo} from '@/api/maintain/plant/list'
import Select from '@/components/common/ui/Select'
import {getLanguageStr} from '@/util/language'
import DashLine from '@/components/common/ui/DashLine'

export default {
  name: 'sourceConfig',
  components: {Loading, Select, DashLine},
  mounted () {
    lib.setScroll($(this.$el).find('[scroll]'))
    lib.fillHeight()
  },
  props: {
      powerType:{//能源类型light,wind
      type:String,
      default:"light"
    }
    // req:{
    //     type: Object,
    // 	default: () => ({})
    // },
    // stationInfo:{
    // 	type: Object,
    // 	default: () => ({})
    // }
  },
  data () {
    return {
    	stage,
      selectHint: {
        irradianceAvailable: lib.getTypeText('', 'configIrrStatus', true), // 辐照
        theoreticalStatisticMethod: lib.getTypeText('', 'configIrrStatus', true), // 理论发电
        generationAvailable:  (function () {
		       let y = lib.getTypeText('', 'configSelectStatus', true);
		       let obj = [	{ id: ['FAN_SUM'], value: 'FAN_SUM', name: getLanguageStr('plant377', '求和风机数据') }]
		          return y.concat(obj)
		      }()),
        gridAvailable: lib.getTypeText('', 'configSelectStatus', true), // 电网 utilityAvailable
        consumptionAvailable: lib.getTypeText('', 'configSelectStatus', true), // 用电
        batteryStatisticMethod: lib.getTypeText('', 'configSelectStatus', true)// 用电
      },
      // activeIndex:{
      //     generationAvailable:0,
      //     gridAvailable:0,
      //     consumptionAvailable:0
      // },
      cloneSelectHint: {},
      activeIndex: {
        irradianceAvailable: null,
        theoreticalStatisticMethod:null,
        generationAvailable: null,
        gridAvailable: null,
        consumptionAvailable: null,
        batteryStatisticMethod: null
      },
      bindGenerationAvailable: null,
      isHint: true,
      metering: {},
      weather:{
      	data:[{ 'textSerialNumber': getLanguageStr('word116', '无'), 'serialNumber':null, value: null}],
      	total:0
      },
      weatherTheoretical:{
      	data:[{ 'textSerialNumber': getLanguageStr('word116', '无'), 'serialNumber': null, value: null}],
      	total:0
      },
      isManual: true,
      stationInfo: null,
      basicInfo: null,
      isPurchase: false
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    selectZh (val) {
      switch (val) {
        case 'INVERTER_SUM':return getLanguageStr('word1965', '求和逆变器数据')
          break
        case 'METER':return getLanguageStr('word1966', '求和电表数据')
          break
        case 'PV_MODULE_SUM':return getLanguageStr('plant_detail30', '求和组件数据')
          break
        case 'WEATHER_AVG':return getLanguageStr('phrase658', '平均气象站数据')
          break
          case 'ALGORITHMIC':return getLanguageStr('plant_detail22', '算法计算')
          break
          case 'FAN_SUM':return getLanguageStr('plant377', '求和风机数据')
          break
          // case 'API_SUM':return getLanguageStr('plant_detail382', '求和API接口')
          // break
        case null :return getLanguageStr('word116', '无')
          break
      }
    },
    SettingStrategy (val) {
      switch (val) {
        case 'STATIC':return getLanguageStr('plant_detail120', '手动修改')
          break
        case 'DYNAMIC':return getLanguageStr('word1362', '系统智能选择')
          break
        default: return '--'
      }
    },

    show (id) {
      this.reset()
      this._getTotalInfo(id)
    },
    reset () {
      this.isHint = true
      this.isManual = true
      this.isPurchase = false
    },
    change () {
      this.isManual = false
      lib.setScroll($(this.$el).find('[scroll]'))
      lib.fillHeight()
    },
    cancel () {
      this.isManual = true
      for (let attr in this.cloneSelectHint) {
        this.activeIndex[attr] = this.cloneSelectHint[attr]
      }
    },
    _getTotalInfo (id) {
      this.isHint = true
      Promise.all([this._getBasicInfo(id), this._stationInfo(id), this.getMetering(id),this.getWeatherList(id)]).then(result => {
        this.isHint = false
        this.basicInfo = result[0]
          	//分布式自发自用余量并网
	    if(this.basicInfo.gridInterconnectionType=='EXCESS'){
          	this.selectHint.generationAvailable.splice(2, 0, {id: ['PV_MODULE_SUM'], value: 'PV_MODULE_SUM', name: getLanguageStr('plant_detail30', '求和组件数据')})
          	this.selectHint.generationAvailable.push({ id: ['ALGORITHMIC'], value: 'ALGORITHMIC', name: getLanguageStr('plant_detail22', '算法计算') })
       		this.selectHint.gridAvailable.push({ id: ['ALGORITHMIC'], value: 'ALGORITHMIC', name: getLanguageStr('plant_detail22', '算法计算') }) 
        	this.selectHint.consumptionAvailable.push({ id: ['ALGORITHMIC'], value: 'ALGORITHMIC', name: getLanguageStr('plant_detail22', '算法计算') }) 
	     }else{
	     	 this.selectHint.generationAvailable.splice(2, 0, {id: ['PV_MODULE_SUM'], value: 'PV_MODULE_SUM', name: getLanguageStr('plant_detail30', '求和组件数据')})
	     }
        this.stationInfo = result[1]
        this.metering = result[2]
        if(result[3].total>0){
           	//请注意当气象站大于1个时，取随机某个气象站
           	result[3].data.forEach(item=>{
           		    item.textSerialNumber=item.serialNumber
					this.weather.data.push(item)
				})
//       	let i=Math.floor(Math.random()*result[3].total);
//       	this.weather.data.push(result[3].data[i])
//       	this.weatherTheoretical.data.push(result[3].data[i])
         	this.weather.total=result[3].total
         	this.weatherTheoretical=this.weather
         }
//       }else if(result[3].total>0){
//      	this.weatherTheoretical.total=result[3].total
//      	 this.weather.data.push(result[3].data[0])
//      	 this.weatherTheoretical.data.push(result[3].data[0])
//       }
        this._configSelect()
      }, error => {
        this.isHint = false
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    // 获取基础信息
    _getBasicInfo (id) {
      return new Promise((resolve, reject) => {
        StationBasicInfo(id).then(res => {
          resolve(res)
        }, error => {
          reject(error)
          // !_.isEmpty(error) && this.$notify(error)
        })
      })
    },
    // 是否更新配置api
    _stationInfo (id) {
      return new Promise((resolve, reject) => {
        StationInfo(id).then(res => {
          resolve(res)
        }, error => {
          reject(error)
        })
      })
    },
    // 获取理论自发自用率
    getMetering (id) {
      return new Promise((resolve, reject) => {
        equipmentApi.StationMetering(id).then(response => {
          resolve(response)
        }, error => {
          reject(error)
        })
      })
    },
    //获取该电站下的气象站列表
    getWeatherList(id){
    	return new Promise((resolve, reject) => {
	        equipmentApi.OperationWeather(id).then(response => {
	          resolve(response)
	        }, error => {
	          reject(error)
	        })
      })
    },
    // 来源设置选项
    _configSelect () {
      if (this.metering.statisticMethodSettingStrategy == 'DYNAMIC') {
        this.stationInfo && this.stationInfo.irradianceStatisticMethod ? this.activeIndex.irradianceAvailable = this.stationInfo.irradianceStatisticMethod : this.activeIndex.irradianceAvailable = null
        this.stationInfo && this.stationInfo.theoreticalStatisticMethod ? this.activeIndex.theoreticalStatisticMethod = this.stationInfo.theoreticalStatisticMethod : this.activeIndex.theoreticalStatisticMethod = null
        this.stationInfo && this.stationInfo.generationStatisticMethod ? this.activeIndex.generationAvailable = this.stationInfo.generationStatisticMethod : this.activeIndex.generationAvailable = null
        this.stationInfo && this.stationInfo.gridStatisticMethod ? this.activeIndex.gridAvailable = this.stationInfo.gridStatisticMethod : this.activeIndex.gridAvailable = null
        this.stationInfo && this.stationInfo.consumptionStatisticMethod ? this.activeIndex.consumptionAvailable = this.stationInfo.consumptionStatisticMethod : this.activeIndex.consumptionAvailable = null
        this.stationInfo && this.stationInfo.batteryStatisticMethod ? this.activeIndex.batteryStatisticMethod = this.stationInfo.batteryStatisticMethod : this.activeIndex.batteryStatisticMethod = null
      } else {
        this.activeIndex = {
          irradianceAvailable: this.metering.irradianceMethod,
          theoreticalStatisticMethod: this.metering.theoreticalStatisticMethod,
          generationAvailable: this.metering.generationStatisticMethod,
          gridAvailable: this.metering.utilityStatisticMethod,
          consumptionAvailable: this.metering.consumptionStatisticMethod,
          batteryStatisticMethod: this.metering.batteryStatisticMethod
        }
      }
      // configApi.configSelect(id).then(response=>{
      // 	this.isHint=false
      // 	let {generationAvailable,gridAvailable,consumptionAvailable,irradianceAvailable}=response
      // 	if(generationAvailable.length==0){
      // 		this.selectHint.generationAvailable=[{type:null,text:getLanguageStr('word116','无')}]
      // 		this.activeIndex.generationAvailable=null
      // 	}else{
      // 		this.selectHint.generationAvailable=generationAvailable.map(el=>({ //发电下拉选择
      // 			value:el,
      // 			text:this.selectZh(el),
      // 		}))
      // 		if(this.metering.statisticMethodSettingStrategy !=null){
      // 			if(this.metering.statisticMethodSettingStrategy=='STATIC'){
      // 				if(generationAvailable.indexOf(this.metering.generationStatisticMethod)==-1){
      // 					if(response.generationMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.generationAvailable=response.generationAvailable[0]
      // 					}else{
      // 						this.activeIndex.generationAvailable=response.generationMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.generationAvailable=this.metering.generationStatisticMethod
      // 				}
      // 			}else{
      // 				if(generationAvailable.indexOf(this.stationInfo.generationStatisticMethod)==-1){
      // 					if(response.generationMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.generationAvailable=response.generationAvailable[0]
      // 					}else{
      // 						this.activeIndex.generationAvailable=response.generationMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.generationAvailable=this.stationInfo.generationStatisticMethod
      // 				}
      // 			}
      // 		}
      // 	}
      // 	if(gridAvailable.length==0){
      // 		this.selectHint.gridAvailable=[{type:null,text:getLanguageStr('word116','无')}]
      // 		this.activeIndex.gridAvailable=null
      // 	}else{
      // 		this.selectHint.gridAvailable=gridAvailable.map(el=>({  //电网下拉选择
      // 			value:el,
      // 			text:this.selectZh(el),
      // 		}))
      // 		if(this.metering.statisticMethodSettingStrategy !=null){
      // 			if(this.metering.statisticMethodSettingStrategy=='STATIC'){
      // 				if(gridAvailable.indexOf(this.metering.utilityStatisticMethod)==-1){
      // 					if(response.utilityStatisticMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.gridAvailable=response.gridAvailable[0]
      // 					}else{
      // 						this.activeIndex.gridAvailable=response.utilityStatisticMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.gridAvailable=this.metering.utilityStatisticMethod
      // 				}
      // 			}else{
      // 				if(gridAvailable.indexOf(this.stationInfo.utilityStatisticMethod)==-1){
      // 					if(response.utilityStatisticMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.gridAvailable=response.gridAvailable[0]
      // 					}else{
      // 						this.activeIndex.gridAvailable=response.utilityStatisticMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.gridAvailable=this.stationInfo.utilityStatisticMethod
      // 				}
      // 			}
      // 		}
      // 	}
      // 	if(consumptionAvailable.length==0){
      // 		this.selectHint.consumptionAvailable=[{type:null,text:getLanguageStr('word116','无')}]
      // 		this.activeIndex.consumptionAvailable=null
      // 	}else{
      // 		this.selectHint.consumptionAvailable=consumptionAvailable.map(el=>({ //用电下拉选择
      // 			value:el,
      // 			text:this.selectZh(el),
      // 		}))
      // 		if(this.metering.statisticMethodSettingStrategy !=null){
      // 			if(this.metering.statisticMethodSettingStrategy=='STATIC'){
      // 				if(consumptionAvailable.indexOf(this.metering.consumptionStatisticMethod)==-1){
      // 					if(response.consumptionMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.consumptionAvailable=response.consumptionAvailable[0]
      // 					}else{
      // 						this.activeIndex.consumptionAvailable=response.consumptionMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.consumptionAvailable=this.metering.consumptionStatisticMethod
      // 				}
      // 			}else{
      // 				if(consumptionAvailable.indexOf(this.stationInfo.consumptionStatisticMethod)==-1){
      // 					if(response.consumptionMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.consumptionAvailable=response.consumptionAvailable[0]
      // 					}else{
      // 						this.activeIndex.consumptionAvailable=response.consumptionMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.consumptionAvailable=this.stationInfo.consumptionStatisticMethod
      // 				}
      // 			}
      // 		}
      // 	}
      // 	if(irradianceAvailable.length==0){
      // 		this.selectHint.irradianceAvailable=[{type:null,text:getLanguageStr('word116','无')}]
      // 		this.activeIndex.irradianceAvailable=null
      // 	}else{
      // 		this.selectHint.irradianceAvailable=irradianceAvailable.map(el=>({ //用电下拉选择
      // 			value:el,
      // 			text:this.selectZh(el),
      // 		}))
      // 		if(this.metering.statisticMethodSettingStrategy !=null){
      // 			if(this.metering.statisticMethodSettingStrategy=='STATIC'){
      // 				if(irradianceAvailable.indexOf(this.metering.irradianceStatisticMethod)==-1){
      // 					if(response.irradianceMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.irradianceAvailable=response.irradianceAvailable[0]
      // 					}else{
      // 						this.activeIndex.irradianceAvailable=response.irradianceMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.irradianceAvailable=this.metering.irradianceStatisticMethod
      // 				}
      // 			}else{
      // 				if(irradianceAvailable.indexOf(this.stationInfo.irradianceStatisticMethod)==-1){
      // 					if(response.irradianceMethod==null){//如果没有推荐就取第一个
      // 						this.activeIndex.irradianceAvailable=response.irradianceAvailable[0]
      // 					}else{
      // 						this.activeIndex.irradianceAvailable=response.irradianceMethod
      // 					}
      // 				}else{
      // 					this.activeIndex.irradianceAvailable=this.stationInfo.irradianceStatisticMethod
      // 				}
      // 			}
      // 		}
      // 	}
      // 	this.cloneSelectHint=_.cloneDeep(this.activeIndex)
      // },error=>{
      // 	this.isHint=false
      // 	this.selectHint={
      // 		irradianceAvailable:[{type:'',text:'--'}],//发电
      // 		generationAvailable:[{type:'',text:'--'}],//发电
      // 		gridAvailable:[{type:'',text:'--'}],//电网
      // 		consumptionAvailable:[{type:'',text:'--'}]//用电
      // 	}
      // 	!_.isEmpty(error) && this.$notify(error)
      // })
    },
		 // 辐照
    activeIrradiance (index) {
      this.activeIndex.irradianceAvailable = this.weather.data[index].serialNumber
    },
    //理论发电
     theoreticalStatisticMethod (index) {
      this.activeIndex.theoreticalStatisticMethod = this.weatherTheoretical.data[index].serialNumber
    },
    // 发电
    activeGeneration (index) {
    	if((this.activeIndex.gridAvailable=='ALGORITHMIC'||this.activeIndex.consumptionAvailable=='ALGORITHMIC')&&this.selectHint.generationAvailable[index].value =='ALGORITHMIC'){
    		this.$notify(getLanguageStr('plant_detail31', '不允许重复选择算法计算'))
    		this.$nextTick(() => {
    			//当两个选择了算法计算时重新置回原先选择
    			this.activeIndex.generationAvailable=this.metering.generationStatisticMethod
    		})
    		return false
    	}else{
    		 this.activeIndex.generationAvailable = this.selectHint.generationAvailable[index].value
    	}
    },
    // 电网
    activeUtility (index) {
    	if((this.activeIndex.generationAvailable=='ALGORITHMIC'||this.activeIndex.consumptionAvailable=='ALGORITHMIC')&&this.selectHint.gridAvailable[index].value =='ALGORITHMIC'){
    		this.$notify(getLanguageStr('plant_detail31', '不允许重复选择算法计算'))
    		this.$nextTick(() => {
    			this.activeIndex.gridAvailable= this.metering.utilityStatisticMethod
    		})
    		return false
    	}else{
     		 this.activeIndex.gridAvailable = this.selectHint.gridAvailable[index].value
    	}
    },
    // 用电
    activeConsumption (index) {
    	if((this.activeIndex.gridAvailable=='ALGORITHMIC'||this.activeIndex.gridAvailable=='ALGORITHMIC')&&this.selectHint.consumptionAvailable[index].value =='ALGORITHMIC'){
    		this.$notify(getLanguageStr('plant_detail31', '不允许重复选择算法计算'))
    		this.$nextTick(() => {
    			this.activeIndex.consumptionAvailable= this.metering.consumptionStatisticMethod
    		});
    		return false
    	}else{
    		this.activeIndex.consumptionAvailable = this.selectHint.consumptionAvailable[index].value
    	}
    },
    batteryStatisticMethodClick (index) {
      this.activeIndex.batteryStatisticMethod = this.selectHint.batteryStatisticMethod[index].value
    },
    saveStatic () {
      let request = {
        strategy: 'DYNAMIC'
      }
      StationMeteringStrategy(this.metering.powerStationId, request).then(res => {
        this.$emit('refresh')
        this.$emit('close')
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    // 保存设置
    saveSetting () {
      this.isHint = true
      let request = {}
      if (this.basicInfo.gridInterconnectionType == 'EXCESS') {
        request = {
          'irradianceStatisticMethod': this.activeIndex.irradianceAvailable,
          'theoreticalStatisticMethod':this.activeIndex.theoreticalStatisticMethod,
          'generationStatisticMethod': this.activeIndex.generationAvailable,
          'utilityStatisticMethod': this.activeIndex.gridAvailable,
          'consumptionStatisticMethod': this.activeIndex.consumptionAvailable,
          'repeatedHint': true
        }
      } else if (this.basicInfo.gridInterconnectionType == 'BATTERY_BACKUP') {
        request = {
          'irradianceStatisticMethod': this.activeIndex.irradianceAvailable,
          'theoreticalStatisticMethod':this.activeIndex.theoreticalStatisticMethod,
          'generationStatisticMethod': this.activeIndex.generationAvailable,
          'utilityStatisticMethod': this.activeIndex.gridAvailable,
          'consumptionStatisticMethod': this.activeIndex.consumptionAvailable,
          'batteryStatisticMethod': this.activeIndex.batteryStatisticMethod,
          'repeatedHint': true
        }
      } else {
        request = {
          'irradianceStatisticMethod': this.activeIndex.irradianceAvailable,
          'theoreticalStatisticMethod':this.activeIndex.theoreticalStatisticMethod,
          'generationStatisticMethod': this.activeIndex.generationAvailable,
          'repeatedHint': true
        }
      }
      StationMeteringSetting(this.metering.powerStationId, request).then(response => {
        this.$emit('close')
        this.isHint = false
        // 刷新总的偏移量
        // this.$emit('configAll', this.totalOffset)
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.flexSys{
	.round{
		width: 1.5em;
		height: 1.5em;
		border-radius: 100%;
		text-align: center;
		line-height: 1.5em
	}
	.flex1{
		flex: 1
	}
	.l18x{
		line-height: 18px
	}
}
.img-box{
	width: 100%
}
.dpN-min{display: none}
.switchText{
	top: 59%;
    right: -1em;
}
    .img-box{
		width: 35em;
		.lText{
			top:70%;
 			left: 5.2em;
		}
		.fanlText{
			top:117%;
 			left: 0.5em;
		}
		.rText{
			top:70%;
			right: 0em;
		}
		.fanrText{
			top:117%;
			right: 0.1em;
		}
		.excessLBText {
			left:0;
			bottom: -1.5em;
		}
		.excessFLBText{
			left: 14%;
   			 bottom: 1.5em;
		}
		.excessLText{
			top: 57%;
    	    left: 5em;
		}
		.excessRText{
			top: 57%;
    	    right: 0em;
		}
		.excessBText{
			left: 56%;
    		bottom: -1.5em;
		}
		.batterylText{
			left: 19%;
    		top: 4em;
		}
		.batteryrText{
		    right: 0%;
			top: 4em;
		}
		.batteryBText{
			bottom: -0.5em;
    		left: 20%;
		}
		.batteryBRText {
			 right: 0%;
			bottom: -1em;
		}
		.switchText{
			right: 4em;
  		    top: 32%;
		}
		.batteryLBText {
		    left: -7%;
       		top: 66%;
		}
	}
	.dpN-min{display: block}
.transformDashLine{
	position:absolute;
	top: 3em;
    left: 3em;
	transform: rotate(52deg);
    transform-origin: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationSourceConfig.vue